import { React, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import AuthenticationBox from './AuthenticationBox';
import SecondAuthenticationBox from './SecondAuthenticationBox';
import { useLanguage } from '../../../Context/LanguageContext';

const SecondUserAuthenticationView = forwardRef((props, ref) => {
  const { clickFn } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const TopLevelRef = useRef();

  useImperativeHandle(ref, () => ({
		setOpacity: (val) => {
			TopLevelRef.current.style.opacity = val;
		},
    setZindex: (val) => {
			TopLevelRef.current.style.zIndex = val;
    }
	}))

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <TitleWrapper>
        <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('statistics.auth.secondPasswordInput')}</Text>
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('statistics.auth.securityDesc')}</Text>
      </TitleWrapper>
      {/* <AuthenticationBox clickFn={clickFn}/> */}
      <SecondAuthenticationBox clickFn={clickFn}/>
    </TopLevelWrapper>
  )
})

export default SecondUserAuthenticationView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 1020px;
  height: 700px;

  z-index: 3;
  opacity: 1;
  
  transition: all 0.3s ease-in-out;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 4px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
